// import Rx from 'rxjs/Rx'
// import {Observable} from 'rxjs'
import { Record } from 'immutable'
import { assign } from 'lodash'
// import Cookies from 'universal-cookie'
import { INIT } from '../../constants/phase'

import { combineEpics } from 'redux-observable'

import * as api from './api'
// import { Empty } from 'antd'

/***********************************
 * Action Types
 ***********/
// const cookies = new Cookies()
export const GET_NOTIFICATIONS='empire/notifications/GET_NOTIFICATIONS'
export const GET_UNREAD_NOTIFICATIONS_COUNT='empire/notifications/GET_UNREAD_NOTIFICATIONS_COUNT'
export const POST_READ_NOTIFICATIONS='empire/notifications/POST_READ_NOTIFICATIONS'
export const POST_CLEAR_NOTIFICATIONS='empire/notifications/POST_CLEAR_NOTIFICATIONS'


/***********************************
 * Initial State
 ***********/

// Unlike other ducks we are taking a class style approach
// for creating the InitialState. This is becuase we need to fetch the
// locally stored token in the constructor when it is created
const InitialStateInterface = {
  // We need this here to tell InitialState that there is a token key,
  // but it will be reset below to what is in localStorage, unless a value
  // is passed in when the object is instanciated
  notifications: [],
  phase: INIT,
  user: null,
  token: null,
  error: null,
  message: null,
}

class InitialState extends Record(InitialStateInterface) {
  constructor(desiredValues) {
    // When we construct InitialState, we automatically update it's default value
    // for token to be what is stored in localStorage
    const token = '' // localStorage.getItem(Config.LocalStorageKeys.Authorization)
    super(assign({ token }, desiredValues))
  }
}

/***********************************
 * Reducer
 ***********/
// eslint-disable-next-line complexity, max-statements

export default function (state = new InitialState(), action = {}) {
  switch (action.type) {
    default: {
      return state
    }
  }
}


/***********************************
 * Action Creators
 ***********/


export const getNotifications = (payload) => {
  return {
    type: GET_NOTIFICATIONS,
    payload: api.getNotifications(payload)
  }
}

export const getUnreadNotificationCount = (payload) => {
  return {
    type: GET_UNREAD_NOTIFICATIONS_COUNT,
    payload: api.getUnreadNotificationCount(payload)
  }
}

export const readNotifications = (payload) => {
  return {
    type: POST_READ_NOTIFICATIONS,
    payload: api.readNotifications(payload)
  }
}

export const clearNotifications = (payload) => {
  return {
    type: POST_CLEAR_NOTIFICATIONS,
    payload: api.clearNotifications(payload)
  }
}

/***********************************
 * Epics
 ***********************************/

export const notificationEpic = combineEpics()
